// // 全局配置公共组件
import PCLogin from "@/components/pc_login.vue";
import PCBind from "@/components/pc_bind.vue";
import PublicHeader from "@/components/publicHeader.vue";
import PublicLoading from "@/components/publicLoading.vue";

export default {
  install(Vue) {
    Vue.component('pclogin', PCLogin) //全局加载中
    Vue.component('pcbind', PCBind) //公共头组件
    Vue.component('publicheader', PublicHeader) //公共头组件
    Vue.component('publicloading', PublicLoading) //公共头组件
  }
}